import React, { useState, useEffect } from "react";
import { formatDate } from "../../utils/date.js";
import "react-intl";
import { DatePicker } from "./DatePicker.js";
import { localized } from "./DateSinglePicker.localize.js";
import { isDateDisabled } from "./utils.js";
const DateSinglePicker = ({
  open,
  value,
  formatter,
  disableFutureDates,
  onChange,
  onDropdownOpen,
  onDropdownClose,
  placeholder,
  disabled,
  locale,
  availableDateRangeForSelection,
  ...textInputProps
}) => {
  const [selectedDate, setSelectedDate] = useState(value);
  const isDateSelected = value !== null && value !== void 0;
  const formattedValue = formatter ? formatter(selectedDate) : formatDate(selectedDate, "date", false);
  useEffect(() => {
    setSelectedDate(value);
  }, [value]);
  const handleSelect = (value2) => {
    setSelectedDate(value2);
    onChange(value2);
    if (onDropdownClose) {
      onDropdownClose();
    }
  };
  return /* @__PURE__ */ React.createElement(
    DatePicker,
    {
      isOpen: open,
      value: selectedDate,
      isDateSelected,
      formattedValue: isDateSelected ? formattedValue : null,
      onSelect: handleSelect,
      defaultMonthDate: selectedDate,
      disableFutureDates,
      onDropdownOpen,
      onDropdownClose,
      placeholder: placeholder ?? localized.datePickerPlaceholder,
      iconPlacement: "end",
      type: "small",
      applyAction: false,
      cancelAction: false,
      locale,
      disabled,
      disabledDateMatcher: (date) => isDateDisabled(date, availableDateRangeForSelection),
      ...textInputProps
    }
  );
};
export {
  DateSinglePicker
};
//# sourceMappingURL=DateSinglePicker.js.map
